/**
 * Idle-teardown policy for the keep-alive 3D Canvas (PR N).
 *
 * `WorkspaceView` keeps the R3F Canvas mounted across 2D↔3D toggles so
 * the toggle is instant (PR M). The downside is ~10–50 MB GPU memory
 * held by an invisible canvas. After {@link IDLE_TEARDOWN_MS} of
 * continuous hiding, we tear it down — the next 3D toggle pays the
 * mount + chunk-load cost again, but the resident-memory pressure
 * disappears.
 *
 * Pure decision over `{ hiddenSinceMs, now }` so the boundary is
 * exhaustively tested.
 */

/** Five minutes of continuous hiding triggers teardown. */
export const IDLE_TEARDOWN_MS = 5 * 60 * 1000;

export interface IdleTeardownInput {
  /** Wall-clock ms when the canvas was last visible→hidden transition. */
  hiddenSinceMs: number | null;
  now: number;
}

export function shouldTearDown3d(input: IdleTeardownInput): boolean {
  if (input.hiddenSinceMs === null) return false;
  return input.now - input.hiddenSinceMs >= IDLE_TEARDOWN_MS;
}
